// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-row {
  background: #FFFFFF;
  box-shadow: 0px 3px 4px rgba(173, 173, 173, 0.25);
  border-radius: 2px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  color: #1F1F1F;
}

.table-header {
  z-index: 1;
  display: flex;
  align-items: center;
  color: #1F1F1F;
}

.main-background {
  background: #FFFFFF;
  box-shadow: 0px 3px 4px rgba(173, 173, 173, 0.25);
  border-radius: 2px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #1F1F1F;
}

li.active.pagination-item span {
  box-sizing: border-box;
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 14px;
  gap: 10px;
  width: 36px;
  height: 40px;
  background: #3D619C !important;
  border: 1px solid #DEE2E6;
  color: white !important;
  /* Inside auto layout */
  flex: none;
  flex-grow: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

li.pagination-item .page-link {
  /* body */
  box-sizing: border-box;
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 14px;
  gap: 10px;
  width: 36px;
  height: 40px;
  /* /Gray / White */
  background: #FFFFFF !important;
  color: black !important;
  /* Stroke/light */
  border: 1px solid #DEE2E6;
  /* Inside auto layout */
  flex: none;
  flex-grow: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

li.pagination-item-prev-next.disabled-pagination-item .page-link {
  box-sizing: border-box;
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 14px;
  gap: 10px;
  width: 56px;
  height: 40px;
  /* /Gray / White */
  background: #FFFFFF;
  /* Stroke/light */
  border: 1px solid #DEE2E6;
  border-radius: 4px 0px 0px 4px;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  /* body */
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* Secondary/Light Color */
  color: #ABB5BE;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

li.pagination-item-prev-next .page-link {
  box-sizing: border-box;
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 14px;
  gap: 10px;
  width: 56px;
  height: 40px;
  /* /Gray / White */
  background: #FFFFFF;
  /* Stroke/light */
  border: 1px solid #DEE2E6;
  border-radius: 4px 0px 0px 4px;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  /* body */
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* Secondary/Light Color */
  color: black;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

.page-item .active {
  background: #FFFFFF;
  box-shadow: 0px 4px 3px rgba(194, 194, 194, 0.25);
}

.filter {
  box-sizing: border-box;
  position: absolute;
  width: 128px;
  height: 36px;
  background: #F2F3F6;
  border: 1px solid #3D619C;
  border-radius: 50px;
  font-family: "Roboto";
  display: flex;
  align-items: center;
  color: #3D619C;
}

.table-row-with-on-click-handler:hover {
  cursor: pointer;
}

.table-title {
  display: flex;
  align-items: center;
  text-align: left;
  color: "black";
}

.hide {
  visibility: hidden;
  display: none;
}

.active-filters {
  flex-grow: 1;
  flex-basis: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomTableRow.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,iDAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAMA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,iDAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAHJ;;AAMA;EACI,sBAAA;EAEA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EAEA,8BAAA;EACA,yBAAA;EACA,uBAAA;EAEA,uBAAA;EACA,UAAA;EACA,YAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AARJ;;AAYA;EACI,SAAA;EACA,sBAAA;EAEA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EAEA,uBAAA;EACA,UAAA;EACA,YAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAZJ;;AAeA;EACI,sBAAA;EAEA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,iBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EAGA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,0BAAA;EACA,cAAA;EAGA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AAtBJ;;AAyBA;EAEI,sBAAA;EAEA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,iBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EAGA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,0BAAA;EACA,YAAA;EAGA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AAjCJ;;AAoCA;EACI,mBAAA;EACA,iDAAA;AAjCJ;;AAoCA;EACI,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAjCJ;;AAqCA;EACI,eAAA;AAlCJ;;AAqCA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAlCJ;;AAqCA;EACI,kBAAA;EACA,aAAA;AAlCJ;;AAqCA;EACI,YAAA;EACA,aAAA;AAlCJ","sourcesContent":[".custom-row {\n    background: #FFFFFF;\n    box-shadow: 0px 3px 4px rgba(173, 173, 173, 0.25);\n    border-radius: 2px;\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: normal;\n    font-size: 13px;\n    text-align: left;\n    color: #1F1F1F;\n\n    // &:hover {\n    //     background: $customTableRowOnHoverColor;\n    // }\n}\n\n.table-header {\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    color: #1F1F1F;\n}\n\n.main-background {\n    background: #FFFFFF;\n    box-shadow: 0px 3px 4px rgba(173, 173, 173, 0.25);\n    border-radius: 2px;\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #1F1F1F;\n}\n\nli.active.pagination-item span {\n    box-sizing: border-box;\n\n    /* Auto layout */\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 12px 14px;\n    gap: 10px;\n\n    width: 36px;\n    height: 40px;\n\n    background: #3D619C !important;\n    border: 1px solid #DEE2E6;\n    color: white !important;\n\n    /* Inside auto layout */\n    flex: none;\n    flex-grow: 0;\n\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n\n}\n\nli.pagination-item .page-link {\n    /* body */\n    box-sizing: border-box;\n\n    /* Auto layout */\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 12px 14px;\n    gap: 10px;\n    width: 36px;\n    height: 40px;\n    /* /Gray / White */\n    background: #FFFFFF !important;\n    color: black !important;\n    /* Stroke/light */\n    border: 1px solid #DEE2E6;\n\n    /* Inside auto layout */\n    flex: none;\n    flex-grow: 0;\n\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n}\n\nli.pagination-item-prev-next.disabled-pagination-item .page-link {\n    box-sizing: border-box;\n\n    /* Auto layout */\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 12px 14px;\n    gap: 10px;\n\n    width: 56px;\n    height: 40px;\n\n    /* /Gray / White */\n    background: #FFFFFF;\n\n    /* Stroke/light */\n    border: 1px solid #DEE2E6;\n    border-radius: 4px 0px 0px 4px;\n\n    /* Inside auto layout */\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n\n\n    /* body */\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n\n    /* Secondary/Light Color */\n    color: #ABB5BE;\n\n\n    /* Inside auto layout */\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n}\n\nli.pagination-item-prev-next .page-link {\n\n    box-sizing: border-box;\n\n    /* Auto layout */\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 12px 14px;\n    gap: 10px;\n\n    width: 56px;\n    height: 40px;\n\n    /* /Gray / White */\n    background: #FFFFFF;\n\n    /* Stroke/light */\n    border: 1px solid #DEE2E6;\n    border-radius: 4px 0px 0px 4px;\n\n    /* Inside auto layout */\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n\n\n    /* body */\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n\n    /* Secondary/Light Color */\n    color: black;\n\n\n    /* Inside auto layout */\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n}\n\n.page-item .active {\n    background: #FFFFFF;\n    box-shadow: 0px 4px 3px rgba(194, 194, 194, 0.25);\n}\n\n.filter {\n    box-sizing: border-box;\n    position: absolute;\n    width: 128px;\n    height: 36px;\n    background: #F2F3F6;\n    border: 1px solid #3D619C;\n    border-radius: 50px;\n    font-family: 'Roboto';\n    display: flex;\n    align-items: center;\n    color: #3D619C;\n}\n\n\n.table-row-with-on-click-handler:hover {\n    cursor: pointer;\n}\n\n.table-title {\n    display: flex;\n    align-items: center;\n    text-align: left;\n    color: \"black\";\n}\n\n.hide {\n    visibility: hidden;\n    display: none;\n}\n\n.active-filters{\n    flex-grow: 1;\n    flex-basis: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
